import { render, staticRenderFns } from "./AvatarIconContent.vue?vue&type=template&id=0495c263"
import script from "./AvatarIconContent.vue?vue&type=script&lang=js"
export * from "./AvatarIconContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports